import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useId } from '../../Utils/Hooks';

import * as Styles from './index.styles';

export const InputByQuantity = ({
    label,
    stepValue,
    initialValue,
    limitToZero,
    onChange,
    ...otherProps
}) => {
    const { StyledWrapper, StyledLabel, StyledControlsWrapper, StyledIcon, StyledInput } = Styles;

    const [value, setValue] = useState(initialValue || stepValue);
    const [displayValue, setDisplayValue] = useState(value);
    const [disableDecrement, setDisableDecrement] = useState();
    const [idIncrement] = useId('increment-action');
    const [idDecrement] = useId('decrement-action');

    const handleDecrementClicked = () => {
        const result = value - stepValue;
        const isLessThanZero = result <= 0;
        if (limitToZero) {
            setValue(isLessThanZero ? 0 : result);
            return;
        }
        setValue(result);
    };

    const handleIncrementClicked = () => {
        setValue(value + stepValue);
    };

    const handleLimitZero = () => {
        if (!limitToZero) {
            setDisableDecrement(false);
            return;
        }
        const disable = value === 0;
        setDisableDecrement(disable);
    };

    const handleChanged = evt => {
        if (!evt || !evt.target || !evt.target.value || Number.isNaN(evt.target.value)) {
            return;
        }
        const formattedValue = parseInt(evt.target.value, 10);
        setValue(formattedValue);
    };

    React.useEffect(() => {
        setDisplayValue(value);
        handleLimitZero();
        onChange(value);
    }, [value]);

    return (
        <StyledWrapper>
            <StyledLabel>{label}</StyledLabel>
            <StyledControlsWrapper>
                <StyledIcon
                    icon={['fas', 'minus']}
                    disabled={disableDecrement}
                    onClick={handleDecrementClicked}
                    id={idDecrement}
                    data-test-id="decrement-action"
                />
                <StyledInput value={displayValue} onChange={handleChanged} {...otherProps} />
                <StyledIcon
                    icon={['fas', 'plus']}
                    onClick={handleIncrementClicked}
                    id={idIncrement}
                    data-test-id="increment-action"
                />
            </StyledControlsWrapper>
        </StyledWrapper>
    );
};

InputByQuantity.propTypes = {
    label: PropTypes.string,
    stepValue: PropTypes.number,
    initialValue: PropTypes.number,
    limitToZero: PropTypes.bool,
    onChange: PropTypes.func,
};

InputByQuantity.defaultProps = {
    label: '',
    stepValue: 1,
    initialValue: undefined,
    limitToZero: true,
    onChange: () => {},
};

InputByQuantity.Styles = Styles;

export default InputByQuantity;
